import type { MouseEvent, ReactElement } from "react";
import { Icon } from "../ui/Icon/Icon";
import { breadcrumbFor } from "../lib/navigation";
import styles from "./Breadcrumb.module.css";

export interface BreadcrumbProps {
  path: string;
  onNavigate?: (href: string) => void;
}

export function Breadcrumb({ path, onNavigate }: BreadcrumbProps): ReactElement {
  const crumbs = breadcrumbFor(path);
  return (
    <nav aria-label="Breadcrumb" className={styles.bar} data-sticky-top>
      <ol className={styles.list}>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          let node: ReactElement;
          if (isLast) {
            node = (
              <span className={styles.current} aria-current="page">
                {crumb.label}
              </span>
            );
          } else if (crumb.href) {
            node = (
              <a
                href={crumb.href}
                className={styles.link}
                onClick={(event: MouseEvent) => {
                  if (onNavigate && crumb.href) {
                    event.preventDefault();
                    onNavigate(crumb.href);
                  }
                }}
              >
                {crumb.label}
              </a>
            );
          } else {
            node = <span className={styles.link}>{crumb.label}</span>;
          }
          return (
            <li key={`${crumb.label}-${index}`} className={styles.item}>
              {index > 0 ? (
                <Icon name="chevron" size={14} className={styles.sep} />
              ) : null}
              {node}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
